import { Injectable } from "@angular/core";
import { Environment } from '@abp/ng.core';
import { Observable, Subject } from "rxjs";

/*const baseUrl = 'http://localhost:4200';*/

@Injectable({ providedIn: "root" })
export class EnvService implements Environment {
  // The values that are defined here are the default values that can
  // be overridden by env.js
  public production = false;

  public DefaultRole = 'BrokerPortal_App';

  public homeUrl = "";

  public application = {
    baseUrl: this.homeUrl,
    name: 'BrokerPortal',
    navItemProfile: {
      manageProfileUrl: '/manageProfile',
      showManageSecurityLog: true,
      showManageProfile: true
    },
    navItemFullscreen: {
      show: true
    }
  };
  public businessId = "2066";
 // public getPlanCountUrl = "";
  public enrollmentEndDate = "12/01/";
  public CCMP =-1;
  public CCMF = 4;
  public nextYearStartDate = "9/01/";
  public copyright = 'nirvanaHealth';
  public lastUpdate = '02/08/2023';
  public MMID: 'YMULTI-PLAN_23_89_C';

  public brandingLogoConfig: 'brandingETH'
  public excelMaxCount =10000;
  public clientName = "ETH";
  public endDate = "2022-12-1";
  public langFile = "assets/MetaData/langs.eth.json";
  public pcpValidationForCSNP = true;
  public hidePCPValidation = true;
  public showEmailOptIn = true;
  public eftDisabled = true;
  public displayPaymentPage = false;  // false will show tab and true will hide.
  public IsMobileMandatory = false;
  public CallDentalRider = false;
  public IsTroyCellphoneText = false;
  public IsEmailOptions = false;
  public IsTroyMandatoryRaceEth = false;
  public oAuthConfig = {
    issuer: "https://dev-nhconnect-broker.nirvanahealth.com",
    redirectUri: 'http://localhost:4200',
    //redirectUri: 'https://dev.nirvanahealth.com/brokercomms',	//-- Once dev-Api link will be ready then uncomment
    clientId: "BrokerPortal_App",
    responseType: 'code',
    scope: 'BrokerPortal',
    requireHttps: true
  };

  public todayDate: string | undefined = undefined;

  public getTodayFromConfig() : Date {
    return this.todayDate ? new Date(this.todayDate) : new Date();
  }

  public getCurrentYear() : number {
    return this.getTodayFromConfig().getFullYear();
  }


  public apis = {
    default: {
      url: 'https://dev.nirvanahealth.com/brokerapi',
      rootNamespace: 'NirvanaHealth.PortalApi'
    },
    PortalApi: {
      url: 'https://dev.nirvanahealth.com/brokerapi',
      rootNamespace: 'NirvanaHealth.PortalApi',
    },
    PCMApi: {
      url: 'https://dev.nirvanahealth.com/'
    },
    ENRApi: {
      url: 'https://qa-api.nirvanahealth.com/api/enrapi',
    },
    PCPIframe: {
      url: 'https://dev-nhconnect.nirvanahealth.com/',
    },
    FileServiceApi: {
      url: 'https://dev.nirvanahealth.com/NhFileServiceApi/',
    },
  };

  public configurableLangFileUrl = "./assets/MetaData/mydefault.eth.json";

  public showHideSpinnerService = new Subject<boolean>();
  public showHideSpinnerServiceObs: Observable<boolean> = this.showHideSpinnerService.asObservable();

  // These variables 
  public enrollToDate: string = '';
  public enrollFromDate: string = '';
  public isAEPPeriod: boolean = false;
  public isPostAEPPeriod: boolean = false;
  
  spinner = document.getElementById('lp-page-loader2');

  public showSpinner() {
    this.spinner.style.display = 'block';
  }

  public hideSpinner() {
    this.spinner.style.display = 'none';
  }
}
